import { use } from 'react'
import { Link } from 'react-router'

type Props = {
  deliveryRange: Promise<string>
}

export const BottomBar: React.FC<Props> = ({ deliveryRange }) => {
  const range = use(deliveryRange)

  return (
    <div className="sticky bottom-0 z-40">
      <div className="px-6 py-4 max-w-md mx-auto">
        <Link reloadDocument to="/subscription/rose/new" className="flex flex-col items-center px-6 py-3 bg-accent text-white rounded-[56px]">
          <span className="text-[18px] font-bold leading-normal">定期便をはじめる</span>
          {range && <span className="text-[13px] leading-normal">初回のお届け日：{range}</span>}
        </Link>
      </div>
    </div>
  )
}
